import type { FC } from 'react';

interface Props {
  className?: string;
}

const FitnessIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 8h10M7 12h4m6 0h1M7 16h4m6 0h1M3 4h18v16H3V4z"
      />
      <rect x="6" y="10" width="3" height="4" rx="1" strokeWidth="2" />
      <rect x="15" y="10" width="3" height="4" rx="1" strokeWidth="2" />
    </svg>
  );
};

export default FitnessIcon;
